import { api } from '../../../api/axios'
import type { Inscricao, InscricaoFilters, CreateInscricaoPayload, ValidacaoPreco } from '../types'

export interface ListResponse<T> {
  data: T[]
  meta: { total: number; page: number; limit: number; totalPages: number }
}

export interface CreateInscricaoResult {
  inscricoes: Inscricao[]
  total_cobrado: number
}

export const inscricoesService = {
  list: (filters: InscricaoFilters = {}) =>
    api.get<ListResponse<Inscricao>>('/inscricoes', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Inscricao }>(`/inscricoes/${id}`).then(r => r.data.data),

  create: (data: CreateInscricaoPayload) =>
    api.post<{ data: CreateInscricaoResult }>('/inscricoes', data).then(r => r.data.data),

  update: (id: number, data: { categoria?: 'overall' | 'dama'; idarma?: number | null }) =>
    api.put<{ data: Inscricao }>(`/inscricoes/${id}`, data).then(r => r.data.data),

  cancelar: (id: number) =>
    api.patch<{ data: Inscricao }>(`/inscricoes/${id}/cancelar`).then(r => r.data.data),

  validacaoPreco: (params: {
    idatirador: number
    idcampeonato: number
    idmodalidade: number
    idetapa: number
    quantidade?: number
  }) =>
    api
      .get<{ data: ValidacaoPreco }>('/inscricoes/validacoes/preco', { params })
      .then(r => r.data.data),

  trocarModalidade: (id: number, data: { idmodalidade: number; idetapa: number }) =>
    api.patch<{ data: Inscricao }>(`/inscricoes/${id}/trocar-modalidade`, data).then(r => r.data.data),

  excluir: (id: number) =>
    api.delete<{ data: { idinscricao: number; excluida: boolean } }>(`/inscricoes/${id}`).then(r => r.data.data),
}
